import { render, staticRenderFns } from "./not_belong.vue?vue&type=template&id=c4b21840&"
import script from "./not_belong.vue?vue&type=script&lang=js&"
export * from "./not_belong.vue?vue&type=script&lang=js&"
import style0 from "./not_belong.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports